import * as React from 'react'

import { Card } from '~ui/components/content/Card/Card'
import { TSpace } from '~ui/styleGuide/spaces'

type TCardProps = PropsOf<typeof Card>

type TProps = RequiredChildren &
  TCardProps & {
    isMobileOrTablet: boolean
  }

/**
 * Base card used to highlight some important information.
 */
export const InfoCard: React.FC<TProps> = ({ isMobileOrTablet, children, ...cardProps }) => {
  const cardDefaultPadding: TSpace = React.useMemo(
    () => (isMobileOrTablet ? `large` : { vertical: `large`, horizontal: `largePlus` }),
    [isMobileOrTablet],
  )

  return (
    <Card
      bgColor={`bgColors.card`}
      radius={`medium`}
      shadow={`bottomLong`}
      padding={cardDefaultPadding}
      {...cardProps}
    >
      {children}
    </Card>
  )
}
